import { Directive, AfterViewInit, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[TabList]'
})
export class TabListDirective implements AfterViewInit {

  constructor(private elRef: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    setTimeout(()=> this.checkTabPosition(),200);
  }

  @HostListener('window:resize')
  onResize() {
    setTimeout(()=> this.checkTabPosition(),200);
  }

  @HostListener('click', ['$event'])
  onClick(event) {
    setTimeout(()=> this.checkTabPosition(),200);
  }

  checkTabPosition(){
    // Elements widths are too small.
    if(!this.elRef.nativeElement.classList.contains('flex-wrap')) this.renderer.addClass(this.elRef.nativeElement,'flex-wrap')
    let parentWidth = this.elRef.nativeElement.getBoundingClientRect().width;
    let children = this.elRef.nativeElement.children;
    let totalWidth:number = Array.from(children as HTMLElement[]).reduce((total, current) => total += +current.getBoundingClientRect().width  , 0);
    for(let child of children){ 
      this.renderer.removeClass(child.children[0], 'activeAbove');
    }
    if(totalWidth < parentWidth) return // fewer items than container width. No actions needed.
    //console.log('tab positions')
    let gapSize = parseFloat(window.getComputedStyle(this.elRef.nativeElement)?.getPropertyValue('gap'));
    let firstChildComputedStyle = window.getComputedStyle(children[0]);
    let margins = !!children.length ? (parseFloat(firstChildComputedStyle.marginRight) + parseFloat(firstChildComputedStyle.marginLeft ) + gapSize): 0;
    let joinedWidth = 0;
    for(let child of children){
      let elWidth = child.getBoundingClientRect().width + margins;
      joinedWidth += elWidth;
      if(joinedWidth < parentWidth) this.renderer.addClass(child.children[0], 'activeAbove');
      else this.renderer.removeClass(child.children[0],'activeAbove');
    }
  }
}
